import React from 'react';
import {
  Box,
  Button,
  Text,
  Select,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  FormControl,
  IconButton,
  Tooltip,
  Input,
  useToast,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetScheduleData,
  selectedMenu,
  setHeaderText,
} from '../../redux/actions/actions';
import 'flatpickr/dist/themes/material_green.css';
import Flatpickr from 'react-flatpickr';
import {
  getCategories,
  getClasses,
  loadSchedule,
  loadExamSchedule,
  loadExamAnswerSheets,
  getDegree,
  submitQuestionDocs,
  submitCorrectedAnswerDocs,
} from '../../redux/api_calls/apiCalls';
import ScheduleRow from './ScheduleRow';
import { ArrowUpIcon, DownloadIcon } from '@chakra-ui/icons';
import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import { saveAs } from 'file-saver';
 export default function Schedule() {
  const slider = useSelector((state) => state.sliderState.sliderOpen);
  const headerText = useSelector((state) => state.headerState.headerText);
  const { scheduleData, isLoading } = useSelector(
    (state) => state.scheduleState
  );
  const { ExamscheduleData } = useSelector((state) => state.ExamscheduleState);
  const { ExamAnswersData } = useSelector((state) => state.ExamAnswerState);
  const uploadInputRef = useRef(null);
  const uploadAnswerRef = useRef(null);
  const classesData = useSelector((state) => state.classesState.classesData);
  const [selectedClassValue, setSelectedClassValue] = useState('0');
  const classRef = useRef();
   const specificationRef = useRef();
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [finalData, setFinalData] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [timings, setTimings] = useState([]);
  const [degrees, setDegrees] = useState([]);
  const [specification, setSpecification] = useState([]);
  const [Answerdegrees, setAnswerDegrees] = useState([]);
  const [scheduleDegrees, setScheduleDegrees] = useState([]);
  const [schedulepecification, setScheduleSpecification] = useState([]);
  const [selectedScheduleDegreeValue, setSelectedScheduleDegreeValue] = useState('0');
  const [selectedScheduleSpecificationValue, setSelectedScheduleSpecificationValue] = useState('0');
  const [Answerspecification, setAnswerSpecification] = useState([]);
  const toast = useToast();
  
  const [examDegrees, setExamDegrees] = useState('0');
  const [examSpecification, setExamSpecification] = useState('0');
  const [examYear, setExamYear] = useState('0');

  const [answerSheetDegrees, setAnswerSheetDegrees] = useState('0');
  const [answerSheetSpecification, setAnswerSheetSpecification] = useState('0');
  const [answerSheetYear, setAnswerSheetYear] = useState('0');

   useEffect(() => {
     const loadFieldData = async () => {
       var degree1 = await getDegree();
       var data = degree1.data;
       setDegrees(data);
     };
     loadFieldData();
  }, [degrees]);

  useEffect(() => {
     const loadFieldData1 = async () => {
      let degree = await getDegree();
       let data = degree.data;
       setAnswerDegrees(data);
     };
     loadFieldData1();
  }, [Answerdegrees]);

useEffect(() => {
     const loadFieldData2 = async () => {
      let degree = await getDegree();
       let data = degree.data;
       setScheduleDegrees(data);
     };
     loadFieldData2();
  }, [setScheduleDegrees]);


  const getScheduleHandler = () => {
   if (selectedScheduleDegreeValue === '0') {
      alert('Please select a degree!');
      return;
    }
     
    if (selectedClassValue === '0') {
      alert('Please select a class!');
      return;
    }
    if (startDate === '') {
      alert('Please select start date!');
      return;
    }
    if (endDate === '') {
      alert('Please select end date!');
      return;
    }

    
     
    dispatch(
      loadSchedule(
        startDate ,
        endDate,
        selectedClassValue === '0' ? '1' : selectedClassValue,
        selectedScheduleDegreeValue === '0' ? '1' : selectedScheduleDegreeValue,
        selectedScheduleSpecificationValue === '0' ? '1' : selectedScheduleSpecificationValue
      )
    );
  };

  const classChangeHandler = () => {
    setSelectedClassValue(classRef.current.value);
  };

 
  const specificationExamChangeHandler = (event) => {
    setExamSpecification(event);
  };

  const classExamChangeHandler = (event) => {
    setExamYear(event);
  };


 

  useEffect(() => {
    if (scheduleData) {
      let entries = Object.entries(scheduleData);
      if (entries.length) {
        let columns = entries.length;
        let rows = Object.entries(entries[0][1]).length;
        let displayData = new Array(rows)
          .fill(0)
          .map((row) => new Array(columns).fill(0).map((col) => null));
        let col = 0;
        for (let dates in scheduleData) {
          for (let i = 0; i < 6; i++) {
            if (scheduleData[dates][`Session${i + 1}`]) {
              displayData[i][col] = scheduleData[dates][`Session${i + 1}`];
            }
          }
          col++;
        }
        setFinalData(displayData);
        let days = [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ];
        let getDay = (date) => days[new Date(date).getDay()];
        let headerData = entries.map((date) => [
          date[0].split('-').reverse().join('-'),
          getDay(date[0]),
        ]);
        setHeaders(headerData);
        let timingsData = [
          '09:30 - 10:30',
          '11:00 - 12:00',
          '12:00 - 01:00',
          '02:00 - 03:00',
          '04:00 - 05:00',
          '05:00 - 06:00',
        ];
        setTimings(timingsData.slice(0, rows));
      } else {
        setFinalData([]);
      }
    }
  }, [scheduleData]);

  useEffect(() => {
    dispatch(setHeaderText('Schedule'));
    dispatch(getClasses());
    dispatch(getCategories());
    //getDefaultSchedule();
    dispatch(selectedMenu(6));
    return () => dispatch(resetScheduleData());
   }, []);

  useEffect(() => {
     dispatch(resetScheduleData());
   }, [startDate, endDate]);

  const getDefaultExamSchedule = () => {
    dispatch(loadExamSchedule(
        examDegrees === '0' ? null : examDegrees,
        examSpecification === '0' ? null : examSpecification,
        examYear === '0' ? null : examYear
        ));
  };
  useEffect(() => {
     getDefaultExamSchedule();
   }, [ExamscheduleData]);

  const getDefaultExamAnswerSheets = () => {
    dispatch(loadExamAnswerSheets(
        answerSheetDegrees === '0' ? null : answerSheetDegrees,
        answerSheetSpecification === '0' ? null: answerSheetSpecification,
        answerSheetYear === '0' ? null : answerSheetYear
        ));
  };
  useEffect(() => {
   getDefaultExamAnswerSheets();
   }, [ExamAnswersData]);

  const handleClick = (event) => {
    localStorage.setItem('schedule_id', event);
    uploadInputRef.current.click();
  };

  const onChangeFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    var file = event.target.files[0];
    var id = localStorage.getItem('schedule_id');
    const formData = new FormData();
    formData.append('question_doc', file);
    formData.append('exam_schedule_id', id);
    dispatch(submitQuestionDocs(formData));
    toast({
      title: 'Question Uploaded Successfully',
      duration: 3000,
      isClosable: true,
    });
  };

  const handleChangeClick = (event) => {
    localStorage.setItem('answer_id', event);
    uploadAnswerRef.current.click();
  };

  const onChangeUploadCorrectedFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    var file = event.target.files[0];
    var id = localStorage.getItem('answer_id');
    var marks = document.getElementById('marks' + id).value;

    var result = document.getElementById('result' + id).value;
    var student_id = document.getElementById('student_id' + id).value;
    if (marks === '' || result === '') {
      toast({
        title: 'Please enter mark and result and then upload answer sheet',
        duration: 3000,
        isClosable: true,
      });
    } else {
      const formData = new FormData();
      formData.append('answers_doc', file);
      formData.append('exam_answer_id', id);
      formData.append('result', result);
      formData.append('student_id', student_id);
      formData.append('marks', marks);
      dispatch(submitCorrectedAnswerDocs(formData));
      toast({
        title: 'Answer Uploaded Successfully',
        duration: 3000,
        isClosable: true,
        status: 'success',
      });
    }
  };

  const saveFile = (name, subject, data) => {
    var ext = data.substring(data.lastIndexOf('.') + 1);
    if (ext === 'pdf') {
      var oReq = new XMLHttpRequest();
      oReq.open('GET', data, true);
      oReq.responseType = 'blob';
      oReq.onload = function () {
        var file = new Blob([oReq.response], {
          type: 'application/pdf',
        });
        saveAs(file, name + '_' + subject + '.pdf');
      };

      oReq.send();
    } else if (ext === 'doc' || ext === 'docx' || ext === 'txt') {
      fetch(data).then((response) => {
        response.blob().then((blob) => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = name + '_' + subject + '.doc';
          a.click();
        });
      });
    } else {
      fetch(data, {
        method: 'GET',
        headers: {},
      })
        .then((response) => {
          response.arrayBuffer().then(function (buffer) {
            const url = window.URL.createObjectURL(new Blob([buffer]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name + '_' + subject + '.png'); //or any other extension
            document.body.appendChild(link);
            link.click();
          });
        })
        .catch((err) => {
        });
    }
  };

  const handleChange = (event) => {
  setExamDegrees(event);
    const token = JSON.parse(window.localStorage.getItem('user')).access_token;
    fetch(
      'https://simplifyed.io/dev-api/class/api/tutor/getSpecifications/' + event,
      {
        headers: { Authorization: 'Bearer ' + token },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        setSpecification(items.payload.data);
      });
  };

  const handleSpecificationChange = (event) => {
  setAnswerSheetDegrees(event);
    const token = JSON.parse(window.localStorage.getItem('user')).access_token;
    fetch(
      'https://simplifyed.io/dev-api/class/api/tutor/getSpecifications/' + event,
      {
        headers: { Authorization: 'Bearer ' + token },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        setAnswerSpecification(items.payload.data);
      });
  };

  const handleScheduleSpecificationChange = (event) => {
  setSelectedScheduleDegreeValue(event);
    const token = JSON.parse(window.localStorage.getItem('user')).access_token;
    fetch(
      'https://simplifyed.io/dev-api/class/api/tutor/getSpecifications/' + event,
      {
        headers: { Authorization: 'Bearer ' + token },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        setScheduleSpecification(items.payload.data);
      });
  };
   
   const changeExamYear = () => {
    if (examDegrees === '0') {
      alert('Please select a degree!');
      return;
    }
     
    if (examYear === '0') {
      alert('Please select a class!');
      return;
    }
     dispatch(
      loadExamSchedule(
        examDegrees === '0' ? '1' : examDegrees,
        examSpecification === '0' ? '1' : examSpecification,
        examYear === '0' ? '1' : examYear
       
      )
    );

  };

 const changeExamAnswerSpecification = (event) => {
    setAnswerSheetSpecification(event);
  };

  const changeExamAnswerYear = (event) => {
    setAnswerSheetYear(event);
  };

  const getAnswerSheets = () => {
    if (answerSheetDegrees === '0') {
      alert('Please select a degree!');
      return;
    }
     
    if (answerSheetYear === '0') {
      alert('Please select a class!');
      return;
    }
     dispatch(
      loadExamAnswerSheets(
        answerSheetDegrees === '0' ? '1' : answerSheetDegrees,
        answerSheetSpecification === '0' ? '1' : answerSheetSpecification,
        answerSheetYear === '0' ? '1' : answerSheetYear
       
      )
    );

  };

   const specificationChangeHandler = () => {
    setSelectedScheduleSpecificationValue(specificationRef.current.value);
  };
  
  return (
    <Box
      d='flex'
      justifyContent='flex-start'
      alignItems='center'
      flexDirection='column'
      minH='90vh'
      pl={[
        '0',
        '0',
        '0',
        slider ? (window.innerWidth < 1400 ? '18vw' : '13vw') : '7.5vw',
      ]}
      transition='all 350ms ease'
    >
      <Box
        width={['95%', '95%', '95%', '80%']}
        justifyContent='space-between'
        alignItems='center'
        d='flex'
        mb='2rem'
      >
        <Text
          fontSize={['20px', '25px', '30px', '40px']}
          d={['none', 'none', 'none', 'flex']}
          fontWeight='900'
          style={{ fontFamily: 'Mulish, sans-serif' }}
        >
          {headerText}
        </Text>
      </Box>

      <Box
        width={['95%', '95%', '95%', '80%']}
        justifyContent='space-between'
        alignItems='center'
        d='flex'
        mb='2rem'

      >
        <Tabs width={['100%']} variant='unstyled' colorScheme='blue'>
          <TabList style={{ border: 'none', outline: 'none' }}>
            <Tab _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px',fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}>Class Schedule</Tab>
            <Tab _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px', fontFamily: 'Mulish, sans-serif',textTransform:'uppercase'}}  style={{ marginLeft:'10px',fontFamily: 'Mulish, sans-serif' }}>Exam Schedule</Tab>
            <Tab _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px', fontFamily: 'Mulish, sans-serif',textTransform:'uppercase'}}  style={{ marginLeft:'10px' ,fontFamily: 'Mulish, sans-serif'}}>Answer Sheets</Tab>
          </TabList>

          <TabPanels>
            <TabPanel padding='0'>
               <Box bg='white' borderRadius='20px' py='0.2rem'
                    pl='1rem' mt='1rem' pr='1rem' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)' mb='1rem'>
               <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px',textTransform:"uppercase"  }}
                                
                            >

                <Box width='33%'>
                 <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Degree
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    onChange={(e) => handleScheduleSpecificationChange(e.target.value)}
                    fontSize='18px'
                  >
                    <option value='' key='-1'>
                      Select Degree
                    </option>
                    {scheduleDegrees === null ? (
                      <option></option>
                    ) : (
                      scheduleDegrees.map((degreesName, idx) => (
                        <option value={degreesName.id} key={idx}>
                          {degreesName.name}
                        </option>
                      ))
                    )}
                  </Select>
                </Box>

                <Box width='35%'>
                 <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Specialization
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                     fontSize='18px'
                     ref={specificationRef}
                    value={selectedScheduleSpecificationValue}
                    onChange={specificationChangeHandler}
                  >
                    <option value='' key='-1'>
                      Select Specialization
                    </option>
                    {schedulepecification === undefined ? (
                      <option></option>
                    ) : (
                      schedulepecification.map((specificationName, idx) => (
                        <option value={specificationName.id} key={idx}>
                          {specificationName.name}
                        </option>
                      ))
                    )}
                  </Select>
                </Box>
                <Box width='20%'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Class
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '95%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    ref={classRef}
                    value={selectedClassValue}
                    onChange={classChangeHandler}
                    fontSize='18px'
                  >
                    <option value='0' key='-1'>
                      Select a Class
                    </option>
                    {classesData.map((className, idx) => (
                      <option value={className.id} key={idx}>
                        {className.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                </Box>
                <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px',textTransform:"uppercase"  }}
                                
                            >
                <Box width='27%' >
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Start Date
                  </Text>
                  <Input
 placeholder='dd-mm-yyyy'
 size="lg"
 type="date"
 onChange={(event) => {
                       setStartDate(event.target.value);
                    }}
                     style={{
                       
                      borderRadius: '13px',
                     }}
/>
                  
                  
                </Box>

                <Box width='30%' mr='6rem'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select End Date
                  </Text>

                  <Input
 placeholder='dd-mm-yyyy'
 size="lg"
 type="date"
 onChange={(event) => {
                       setEndDate(event.target.value);
                    }}
                     style={{
                       
                      borderRadius: '13px',
                     }}
/>
                </Box>

                <Box
                  height='100%'
                  d='flex'
                  justifyContent='center'
                  alignItems='flex-end'
                >
                  <Button
                    fontSize='16px'
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    colorScheme='messenger'
                    isLoading={isLoading}
                    loadingText='Fetching...'
                    onClick={getScheduleHandler}
                  >
                    Get Schedule
                  </Button>
                </Box>
              </Box>
              </Box>

              <Box width={['100%']} bg='white' borderRadius='20px' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)' 
                    pl='1rem'  pr='2rem'  justifyContent='flex-start' alignItems='center' flexDir='column' d='flex' mb='2rem'>
                {finalData && finalData.length > 0 ? (
                   <Box w='100%' justifyContent='space-between' alignItems='center' d='flex' flexDir='column'>

                    {headers.length > 0 && (
                      <Box
                        width='100%'
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderRadius='20px'
                      >
                        <Box
                          flex='1'
                          height='100px'
                          display='flex'
                          flexDir='column'
                          justifyContent='center'
                          alignItems='center'
                          color='black'

                        >
                          <Text
                            fontStyle='normal'
          lineHeight='18px'
          fontSize='16px'
          fontWeight='700'
          color='black'
          style={{ fontFamily: 'Mulish, sans-serif'  }}
                          >
                            <b>Timings</b>
                          </Text>
                        </Box>
                        {headers.map((day, idx) => (
                          <Box
                            flex='1'
                            height='100px'
                            key={idx}
                            display='flex'
                            flexDir='column'
                            justifyContent='center'
                            alignItems='center'
                            color='black'
                            borderLeft='1px solid rgba(0, 0, 0, 0.1)'
                            borderBottom='1px solid rgba(0, 0, 0, 0.1)'
                          >
                            <Text
                              fontStyle='normal'
                      lineHeight='18px'
                      fontSize='16px'
                      fontWeight='700'
                      color='black'
                      style={{ fontFamily: 'Mulish, sans-serif'  }}
                            >
                              <b>{day[1]}</b>
                            </Text>
                            <Text
                              fontStyle='normal'
                      lineHeight='18px'
                      fontSize='16px'
                      fontWeight='700'
                      color='black'
                      style={{ fontFamily: 'Mulish, sans-serif'  }}
                            >
                              {day[0]}
                            </Text>
                          </Box>
                        ))}
                      </Box>
                    )}

                    {finalData &&
                      finalData.map((session, idx) => (
                        <ScheduleRow
                          key={idx}
                          id={idx}
                          session={session}
                          time={timings[idx]}
                        />
                      ))}
                  </Box>
                ) : (
                  <Box
                    w='100%'
                    justifyContent='space-between'
                    alignItems='center'
                    d='flex'
                    flexDir='column'
                  >
                    <Text>
                      No Schedule Available for selected Class/Date-Range
                    </Text>
                  </Box>
                )}
              </Box>
            </TabPanel>

            <TabPanel padding='0'  >
              <Box
                width={['100%']}
                justifyContent='space-between'
                alignItems='center'
                d='flex'
                mb='2rem'
                fontWeight='900'
                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px' }}
                bg='white' 
                borderRadius='20px' 
                pt='2rem' 
                pb='2rem' 
                pl='1rem'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
              >
                <Box width='33%'>
                 <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Degree
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    onChange={(e) => handleChange(e.target.value)}
                    fontSize='18px'
                  >
                    <option value='' key='-1'>
                      Select Degree
                    </option>
                    {degrees === null ? (
                      <option></option>
                    ) : (
                      degrees.map((degreesName, idx) => (
                        <option value={degreesName.id} key={idx}>
                          {degreesName.name}
                        </option>
                      ))
                    )}
                  </Select>
                </Box>

                <Box width='35%'>
                 <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Specialization
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    
                    onChange={(e) => specificationExamChangeHandler(e.target.value)}
                    fontSize='18px'
                  >
                    <option value='' key='-1'>
                      Select Specialization
                    </option>
                    {specification === undefined ? (
                      <option></option>
                    ) : (
                      specification.map((specificationName, idx) => (
                        <option value={specificationName.id} key={idx}>
                          {specificationName.name}
                        </option>
                      ))
                    )}
                  </Select>
                </Box>
                <Box width='33%'>
                 <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Year
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    // value={examHandlerValues.year_id}
                   onChange={(e) => classExamChangeHandler(e.target.value)}
                    fontSize='18px'
                  >
                    <option value='' key='-1'>
                      Select Year
                    </option>
                    {classesData.map((className, idx) => (
                      <option value={className.id} key={idx}>
                        {className.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                    <Box
                  height='100%'
                  d='flex'
                  justifyContent='center'
                  alignItems='flex-end'
                >
                  <Button
                    fontSize='16px'
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    colorScheme='messenger'
                    isLoading={isLoading}
                    loadingText='Fetching...'
                    onClick={changeExamYear}
                  >
                    Get Exams
                  </Button>
                </Box>
              </Box>
              <Box bg='white' 
                      borderRadius='20px' py='0.2rem'
                      pl='1rem' 
                      pt='2rem' 
                      pr='1rem' 
                      pb='2rem' 
                      boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'>
              {ExamscheduleData === null ? (
                <Text>Exam Schedules Not Available</Text>
              ) : (
                Object.keys(ExamscheduleData).map(function (keyName, keyIndex) {
                  return (
                    <Box
                      width={['100%']}
                      d='flex'
                      justifyContent='space-between'
                      mb='1rem'
                      style={{ marginTop: '40px' }}
                      
                    >
                      <Box width='17%'>
                        <FormControl>
                          <Input
                            type='text'
                            color='#666666'
                            id='date'
                            width='100%'
                            borderRadius='lg'
                            bgColor='#F8F8F8'
                            readOnly={true}
                            value={ExamscheduleData[keyName]['date']}
                            fontSize={['9px', '11px', '13px', '16px']}
                          />
                        </FormControl>
                      </Box>
                      <Box width='17%'>
                        <FormControl>
                          <Input
                            type='text'
                            color='#666666'
                            id='last_name'
                            width='100%'
                            borderRadius='lg'
                            bgColor='#F8F8F8'
                            readOnly={true}
                            value={ExamscheduleData[keyName]['subject']['name']}
                            fontSize={['9px', '11px', '13px', '16px']}
                          />
                        </FormControl>
                      </Box>
                      <Box width='17%'>
                        <FormControl>
                          <Input
                            type='text'
                            color='#666666'
                            id='last_name'
                            width='100%'
                            borderRadius='lg'
                            bgColor='#F8F8F8'
                            readOnly={true}
                            value={ExamscheduleData[keyName]['time_noon']}
                            fontSize={['9px', '11px', '13px', '16px']}
                          />
                        </FormControl>
                      </Box>
                      <Box width='17%'>
                        <FormControl>
                          <Input
                            type='text'
                            color='#666666'
                            id='last_name'
                            width='100%'
                            borderRadius='lg'
                            bgColor='#F8F8F8'
                            readOnly={true}
                            value={ExamscheduleData[keyName]['time']}
                            fontSize={['9px', '11px', '13px', '16px']}
                          />
                        </FormControl>
                      </Box>

                      <Box width='17%'>
                        <FormControl>
                          <Input
                            type='text'
                            color='#666666'
                            id='last_name'
                            width='100%'
                            borderRadius='lg'
                            bgColor='#F8F8F8'
                            readOnly={true}
                            value={ExamscheduleData[keyName]['classes']['name']}
                            fontSize={['9px', '11px', '13px', '16px']}
                          />
                        </FormControl>
                      </Box>

                      <Box width='3%'>
                        <input
                          ref={uploadInputRef}
                          type='file'
                          style={{ display: 'none' }}
                          onChange={onChangeFile}
                          id={ExamscheduleData[keyName]['id']}
                          
                        />
                        <Tooltip label='Upload question paper'>
                          <IconButton
                            isRound
                            colorScheme='btn1'
                            aria-label='Call Segun'
                            size='md'
                            backgroundColor='#00cc66'
                            onClick={() =>
                              handleClick(ExamscheduleData[keyName]['id'])
                            }
                            variant='contained'
                            icon={<ArrowUpIcon color='black' />}
                             disabled={ExamscheduleData[keyName]['exam_Started']===false}
                          />
                        </Tooltip>
                      </Box>

                      {/* <Box d="flex"
                                        justifyContent="flex-end" width="10%" style={{ marginTop: '4px' }}>
                                        <EditIcon w={6} h={6} color="#1A202C" onClick={() => setdisableFieldId(v)} cursor="pointer" />
                                        <DeleteIcon onClick={() => deleteExamScheduleFunc(v.id)} style={{ marginLeft: '16px' }} w={6} h={6} color="#1A202C" cursor="pointer" />
                                    </Box> */}
                    </Box>
                  );
                })
              )}
          </Box>
            </TabPanel>

            <TabPanel padding='0'>
              <Box
                width={['100%']}
                justifyContent='space-between'
                alignItems='center'
                d='flex'
                mb='2rem'
                fontWeight='900'
                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px' }}
                bg='white' 
                borderRadius='20px' py='0.2rem'
                pl='1rem' 
                pt='2rem' 
                pr='1rem' 
                pb='2rem' 
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                >
                <Box width='33%'>
                <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Degree
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    onChange={(e) => handleSpecificationChange(e.target.value)}
                    fontSize='18px'
                  >
                    <option value='' key='-1'>
                      Select Degree
                    </option>
                    {Answerdegrees === null ? (
                      <option></option>
                    ) : (
                      Answerdegrees.map((degreesName, idx) => (
                        <option value={degreesName.id} key={idx}>
                          {degreesName.name}
                        </option>
                      ))
                    )}
                  </Select>
                </Box>

                <Box width='35%'>
                <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Year
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    // value={examHandlerValues.specialization_id}
                   onChange={(e) => changeExamAnswerSpecification(e.target.value)}
                    fontSize='18px'
                  >
                    <option value='' key='-1'>
                      Select Specialization
                    </option>
                    {Answerspecification === undefined ? (
                      <option></option>
                    ) : (
                      Answerspecification.map((degreesName, idx) => (
                        <option value={degreesName.id} key={idx}>
                          {degreesName.name}
                        </option>
                      ))
                    )}
                  </Select>
                </Box>
                <Box width='33%'>
                <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Year
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '85%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                   onChange={(e) => changeExamAnswerYear(e.target.value)}
                    fontSize='18px'
                  >
                    <option value='' key='-1'>
                      Select Year
                    </option>
                    {classesData.map((className, idx) => (
                      <option value={className.id} key={idx}>
                        {className.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                 <Box
                  height='100%'
                  d='flex'
                  justifyContent='center'
                  alignItems='flex-end'
                >
                  <Button
                    fontSize='16px'
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    colorScheme='messenger'
                    isLoading={isLoading}
                    loadingText='Fetching...'
                    onClick={getAnswerSheets}
                  >
                    Get Answers
                  </Button>
                </Box>
              </Box>
              <Box bg='white' 
        borderRadius='20px' py='0.2rem'
        pl='1rem' 
        pt='2rem' 
        pr='1rem' 
        pb='2rem' 
        boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'>
              {ExamAnswersData === undefined ||
              Object.entries(ExamAnswersData).length === 0 ? (
                <Text>Answer Sheets Not Available</Text>
              ) : (
                <Table variant='simple'>
                  <Thead>
                    <Tr>
                      <Th>Name</Th>
                      <Th>Year</Th>
                      <Th>Subject Name</Th>
                      <Th style={{ width: '15%' }}>Marks</Th>
                      <Th>Result</Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {Object.keys(ExamAnswersData).map(function (
                      keyName,
                      keyIndex
                    ) {
                      return (
                        <Tr>
                          <Td>{ExamAnswersData[keyName]['student_name']}</Td>
                          <Td>{ExamAnswersData[keyName]['year']}</Td>
                          <Td>{ExamAnswersData[keyName]['subject_name']}</Td>
                          <Td>
                            <Input
                              type='text'
                              color='#666666'
                              id={'marks' + ExamAnswersData[keyName]['id']}
                              width='100%'
                              borderRadius='lg'
                              bgColor='#f1f2f6'
                              placeholder={ExamAnswersData[keyName]['marks']}
                              fontSize={['9px', '11px', '13px', '16px']}
                              value={ExamAnswersData[keyName]['marks']}
                            />
                            <Input
                              type='hidden'
                              id={
                                'mark_hidden' + ExamAnswersData[keyName]['id']
                              }
                              value={ExamAnswersData[keyName]['marks']}
                            />
                          </Td>
                          <Td>
                            <Select
                              id={'result' + ExamAnswersData[keyName]['id']}
                              width={['100%', '100%', '90%', '85%']}
                              border='1px solid rgba(0, 0, 0, 0.1)'
                              borderRadius='13px'
                              height='40px'
                              // value={examHandlerValues.specialization_id}
                              // onChange={(e) => changeExamScheduleHandler("specialization_id", e.target.value)}
                              fontSize='18px'
                              value={ExamAnswersData[keyName]['result']}
                            >
                              <option value='' key='-1'>
                                Select Result
                              </option>
                              <option value='Pass' key='1'>
                                Pass
                              </option>
                              <option value='Fail' key='2'>
                                Fail
                              </option>
                            </Select>
                            <Input
                              type='hidden'
                              id={'student_id' + ExamAnswersData[keyName]['id']}
                              value={ExamAnswersData[keyName]['student_id']}
                            />
                          </Td>
                          <Td>
                            <Box
                              width={['60%']}
                              justifyContent='space-between'
                              alignItems='center'
                              d='flex'
                            >
                              <Box width='3%'>
                                <Tooltip label='Download Answer Sheet'>
                                  <IconButton
                                    isRound
                                    colorScheme='btn1'
                                    aria-label='Call Segun'
                                    size='md'
                                    icon={<DownloadIcon />}
                                    backgroundColor='#ff944d'
                                    onClick={() =>
                                      saveFile(
                                        ExamAnswersData[keyName][
                                          'student_name'
                                        ],
                                        ExamAnswersData[keyName][
                                          'subject_name'
                                        ],
                                        ExamAnswersData[keyName][
                                          'answers_paper_doc'
                                        ]
                                      )
                                    }
                                  />
                                </Tooltip>
                              </Box>
                              <Box width='3%'>
                                <input
                                  ref={uploadAnswerRef}
                                  type='file'
                                  accept='image/*'
                                  style={{ display: 'none' }}
                                  onChange={onChangeUploadCorrectedFile}
                                  id={ExamAnswersData[keyName]['id']}
                                />
                                <Tooltip label='Upload evaluated papers'>
                                  <IconButton
                                    isRound
                                    colorScheme='btn3'
                                    aria-label='Call Segun'
                                    size='md'
                                    icon={<ArrowUpIcon color='black' />}
                                    backgroundColor='#00cc66'
                                    onClick={() =>
                                      handleChangeClick(
                                        ExamAnswersData[keyName]['id']
                                      )
                                    }
                                  />
                                </Tooltip>
                              </Box>
                            </Box>
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              )}
            </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
}
